import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Typography,
} from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router';
import Section from '../../../layout/Section';
import Button from '../../../common/inputs/Button';
import { AdminOrg } from '../../../../services/api/admin';
import { colors } from '../../../../styles/colors';

interface OrgsSectionProps {
  orgs: AdminOrg[];
  onCreateClick: () => void;
}

const OrgsSection: React.FC<OrgsSectionProps> = ({ orgs, onCreateClick }) => {
  const navigate = useNavigate();

  return (
    <Section
      title="Mandanten"
      actions={
        <Button variant="primary" onClick={onCreateClick}>
          <AddIcon sx={{ mr: 0.5, fontSize: '1rem' }} />
          Mandant anlegen
        </Button>
      }
      noPadding
    >
      {orgs.length === 0 ? (
        <Typography sx={{ p: 3, color: 'text.secondary', textAlign: 'center' }}>
          Noch keine Mandanten vorhanden.
        </Typography>
      ) : (
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ backgroundColor: colors.background.tableHeader }}>
                <TableCell sx={{ fontWeight: 600 }}>Anzeigename</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
                <TableCell sx={{ fontWeight: 600 }}>Identifier</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orgs.map((org) => (
                <TableRow
                  key={org.id}
                  hover
                  onClick={() => navigate(`/admin/organisations/${org.external_id}`)}
                  sx={{ cursor: 'pointer' }}
                >
                  <TableCell>
                    <BusinessIcon
                      sx={{ fontSize: '1rem', mr: 1, verticalAlign: 'middle', color: 'text.secondary' }}
                    />
                    {org.display_name}
                  </TableCell>
                  <TableCell sx={{ color: 'text.secondary', fontFamily: 'monospace', fontSize: '0.8rem' }}>
                    {org.name}
                  </TableCell>
                  <TableCell sx={{ color: 'text.secondary', fontFamily: 'monospace', fontSize: '0.8rem' }}>
                    {org.external_id}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Section>
  );
};

export default OrgsSection;
